import React, { useState } from 'react';
import BaseInput from '../../shared/forms/Input';

const Input = ({onChange, placeholder, type, icon, value, getWarning, label, disabled = false, helperText = '', helperVariant = ''}) => {
  const [warning, setWarning] = useState('');
  const resolvedHelperText = warning || helperText;
  const resolvedHelperVariant = warning ? 'warning' : helperVariant;

  return (
    <BaseInput
      variant="auth"
      label={label}
      type={type}
      value={value}
      placeholder={placeholder}
      icon={icon}
      disabled={disabled}
      helperText={resolvedHelperText}
      helperVariant={resolvedHelperVariant}
      onChange={(event) => {
        if (getWarning) {
          setWarning(getWarning(event.target.value) || '');
        }
        onChange(event);
      }}
    />
  );
}

export default Input;
